module.exports = __webpack_public_path__ + "static/media/plan.bffb472.bffb4722.svg";